import { Component, Output } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../../auth/services/auth.service';
import { SettingsService } from '../../settings/services/settings.service';
import { Angulartics2, Angulartics2Segment } from 'angulartics2';
import { Router } from '@angular/router';

@Component({
    'selector': 'app-header',
    'templateUrl': './header.component.html',
    'styleUrls': [ 'header.component.scss' ]
})

export class AppHeaderComponent {
    public username: string;
    public email: string;
    private appSettings = this.settingsService.Get();
    isLoggedIn = false;

    private isUsingAuth() {
        return this.appSettings.useAuthentication;
    }

    constructor(private oAuthService: OAuthService,
                private authService: AuthService,
                private settingsService: SettingsService,
                private angulartics: Angulartics2Segment,
                private router: Router) {
        this.subscribeToAuthService();
    }

    private subscribeToAuthService() {
        this.authService.onLoggedIn.subscribe(
            (response) => {
                this.isLoggedIn = response;
                if (this.isLoggedIn) {
                    this.loadUserProfile();
                }
            },
        (error) => console.log(error)
        );
    }

    private loadUserProfile() {
        if (this.isUsingAuth() && this.isLoggedIn && this.oAuthService.hasValidAccessToken()) {
            this.oAuthService.loadUserProfile().then((profile: any) => {
                this.username = profile.given_name + ' ' + profile.family_name;
                this.email = profile.email;

                this.angulartics.setUserProperties({
                  userId: profile.sub,
                  name: this.username,
                  email: this.email,
                  organisationId: profile.organisation_id
                });
            });
        }else if (!this.isUsingAuth()) {
            this.username = 'Abathur';
        }
    }

    onPrivacyNoticeClicked() {

        if (this.router.url !== '/privacynotice') {
          this.router.navigate(['/privacynotice'], {});
        }
      }

    onLogoutClicked() {
        // this relies on logoutUrl (connect/endsession) and redirectUri being set on oAuthService in order to work as expected
        if (this.isUsingAuth()) {
            this.oAuthService.logOut();
        }
    }

    public get name() {
        if (this.isUsingAuth()) {
            const claims: any = this.oAuthService.getIdentityClaims();
            if (!claims) {
                return null;
            }
            return claims.given_name;
        }else {
            return 'Abathur';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/header/components/header.component.ts